
import Vue from 'vue'
import { mapActions,mapGetters } from 'vuex'

interface Container {
  id: string
  x: number
  y: number
  width: number
  height: number
  fill: string
  stroke: string
  strokeWidth: number
  type: string
  isReefer: boolean
  is45Foot: boolean
  isTank: boolean
  isFlatRack: boolean
  isOpenTop: boolean
  isPlatform: boolean
}

export default Vue.extend({
  props: {
    data: {
      type: Object as () => {
        cols: number
        rows: number
        cells: {
          existed: boolean
          isReefer: boolean
          is45Foot: boolean
          isTank: boolean
          isFlatRack: boolean
          isOpenTop: boolean
          isPlatform: boolean
        }[]
      },
      default: () => ({
        cols: 5,
        rows: 5,
        cells: [{
          existed: true,
          isReefer: true,
          is45Foot: true,
          isTank: false,
          isFlatRack: false,
          isOpenTop: false,
          isPlatform: false,
        }, {
          existed: false,
          isReefer: true,
          is45Foot: false,
          isTank: false,
          isFlatRack: false,
          isOpenTop: false,
          isPlatform: false,
        }]
      })
    },
    name: {
      type: String,
      default: '01'
    },
    minHoldTiersNo: { default: 0 },
    cellWidth: { default: 5 }
  },
  data() {
    return {
      SPACE_BETWEEN_CELLS: 0,
      OffsetbayX:0,
      blinkColor: '#FF0000',
    }
  },

  mounted() {
    //this.startBlinking();
    //if (this.cellWidth) this.cellWidth = Number(this.cellWidth)
  },
  methods: {
    ...mapActions(["setVesselMonitoringContainerDetail", 'setIsVesselMonitoringContainerDetailModalOpen']),
    handleCellClick(containerData) {
      if (!containerData.existed) return
      this.setVesselMonitoringContainerDetail(containerData)
      this.setIsVesselMonitoringContainerDetailModalOpen(true)
    },
    handleMouseOver(container, evt) {
      if (container.existed) {
        evt.target.style.stroke = '#000000';
        evt.target.style.strokeWidth = '1';
        document.body.style.cursor = 'pointer';
      }
    },
    handleMouseOut(container, evt) {
      if (container.existed) {
        evt.target.style.stroke = '#A0A0A0';
        evt.target.style.strokeWidth = '0.3';
        document.body.style.cursor = 'default';
      }
    },
    hexToRGBA(hex: string, alpha: number = 1): string {
      const match = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      if (!match) {
        throw new Error("Invalid hex format!");
      }
      const [_, r, g, b] = match.map(value => parseInt(value, 16));
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    startBlinking() {
      setInterval(() => {
        this.blinkColor =
          this.blinkColor === this.hexToRGBA('#FF0000', 1)
            ? this.hexToRGBA('#ffffff', 1)
            : this.hexToRGBA('#FF0000', 1);
      }, 1000);
    },
  },
  computed: {
       ...mapGetters(['getShowWeightLevel','getVesselMonitoringType']),
    ShowWeightLevel: {
      get() {
        return this.getShowWeightLevel;
      }},
    getXLabels() {
      let labels = []
      let middle = this.data.cols % 2 === 0 ? this.data.cols / 2 : Math.floor(this.data.cols / 2)
      let startNumber = this.data.cols % 2 === 0 ? 1 : 0
      for (let i = 0; i < this.data.cols; i++) {
        if (this.data.cols % 2 === 0) {
          labels[middle + Math.floor((i * ((-1) ** i)) / 2)] = (i + 1).toString().padStart(2, '0')
        } else {
          labels[middle + Math.ceil((i * ((-1) ** (i - 1))) / 2)] = (startNumber + i).toString().padStart(2, '0')
        }
      }
      return labels
    },
    getYLabels() {
      let labels = []
      for (let i = this.data?.rows; i >= 0; i--) {
        labels.push((this.minHoldTiersNo + i * 2).toString().padStart(2, '0'))
      }
      return labels
    },
    svgWidth() {
      return  this.data.cols * this.cellWidth + 20;
    },
    svgHeight() {
      return this.data.rows * (this.cellWidth + this.SPACE_BETWEEN_CELLS) + 20;
    },
    containers() {
      const cols = this.data.cols
      const rows = this.data.rows
      const newContainers = this.data.cells.map((c, index) => {
      let fill = c.color === null ? '#fafafa' : `#${c.color}`
        let cellData = {
          ...c,
          index,
          x: (index % cols) * (this.cellWidth + this.SPACE_BETWEEN_CELLS) + this.OffsetbayX,
          y: (rows - 1 - Math.floor(index / cols)) * (this.cellWidth ) + 5,
          width: this.cellWidth,
          height: this.cellWidth,
          fill: fill,
          stroke: '#A0A0A0',
          strokeWidth: 0.3,
          type: 'standard',
        }
        if (c.isInBay === false) {
          cellData = {
            ...cellData,
            strokeWidth: 0,
            fill: '#ffffff',
          }
        }
        if ((this.getVesselMonitoringType === "Load" && c.isLoadedWrongPosition) || (this.getVesselMonitoringType === "Discharge" && c.yardPlanningIsObserved != null && !c.yardPlanningIsObserved)) {
          cellData = {
            ...cellData,
            strokeWidth: 1,
            fill:fill,
            stroke: this.blinkColor,
          }
        }
        return cellData
      })
      return newContainers
    }
  }
})
